import { useState, useRef } from "react";
import { createPortal } from "react-dom";

export default function EpicProgressBar({ task_status_count = {} }) {
   
    const {
        task_count: raw_task_count = 0,
          issue_count,
        "TO DO": to_do = 0,
        "DONE": done = 0,
        ...counts
    } = task_status_count || {};

    // Ensure task_count is a number; if not provided, sum the available status counts
    const task_count = Number(raw_task_count) ||
        (Object.values(counts).map((v) => Number(v) || 0).reduce((a, b) => a + b, 0) + Number(to_do || 0) + Number(done || 0));

    const barRef = useRef(null);

    const [tipMessage, setTipMessage] = useState("");
    const [tipStatus, setTipStatus] = useState(false);
    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const statusColors = {
        "TO DO": "#8C8F97",
        "DONE": "#82B536",
        "IN PROGRESS": "#357DE8",
    };

    const handleMouseMove = (e) => {
        setMousePos({
            x: e.clientX,
            y: e.clientY,
        });
    };

    // if there are no tasks, render nothing
    if (!task_count) return null;

    // 🔥 Merge all middle statuses into one "IN PROGRESS"
    const inProgressValue = Object.keys(counts)
        .map((key) => Number(counts[key]))
        .reduce((a, b) => a + b, 0);
       

    const statuses = [
        ...(done ? [{ name: "DONE", value: Number(done), color: statusColors["DONE"] }] : []),
        ...(inProgressValue > 0
            ? [
                {
                    name: "IN PROGRESS",
                    value: inProgressValue,
                    color: statusColors["IN PROGRESS"],
                },
            ]
            : []),
        ...(to_do ? [{ name: "TO DO", value: Number(to_do), color: statusColors["TO DO"] }] : []),
    ];



    return (
        <div
            ref={barRef}
            style={{
                display: "flex",
                width: "100%",
                height: "4px",
                borderRadius: "2px",
                overflow: "hidden", // required for rounded corners
                position: "relative",
                gap: "3px", // 🔥 NO GAP between bars
            }}
            onMouseMove={handleMouseMove}
        >
            {statuses.map((st, i) => {
                const isFirst = i === 0;
                const isLast = i === statuses.length - 1;

                return (
                    <div
                        key={st.name}
                        style={{
                            width: `${(st.value / task_count) * 100}%`,
                            background: st.color,
                            cursor: "pointer",
                            borderTopLeftRadius: isFirst ? "2px" : "0",
                            borderBottomLeftRadius: isFirst ? "2px" : "0",
                            borderTopRightRadius: isLast ? "2px" : "0",
                            borderBottomRightRadius: isLast ? "2px" : "0",
                        }}
                        onMouseEnter={() => {
                            setTipStatus(true);
                            setTipMessage(
                                `${st.name}: ${st.value === 1 ? st.value + " task" : st.value + " tasks"
                                }`
                            );
                        }}
                        onMouseLeave={() => {
                            setTipStatus(false);
                            setTipMessage("");
                        }}
                    ></div>
                );
            })}

            {tipStatus &&
                createPortal(
                    <div
                        style={{
                            position: "fixed",
                            top: mousePos.y + 12,
                            left: mousePos.x + 12,
                            padding: "6px 10px",
                            background: "rgba(0,0,0,0.85)",
                            color: "#fff",
                            fontSize: "12px",
                            borderRadius: "4px",
                            whiteSpace: "nowrap",
                            pointerEvents: "none",
                            zIndex: 999999,
                        }}
                    >
                        {tipMessage}
                    </div>,
                    document.body
                )}
        </div>
    );
}
